import { Modal } from "antd";
import { Icon } from "@iconify/react";
import React from "react";
import "./layouts-styles.css";

/**
 * Dialog shell.
 *
 * Title is a display-face line with an optional subtitle underneath and
 * an icon chip, rather than the old "Main | Sub" run-on. Width collapses
 * on phones so a form never sits in a 520px box on a 375px screen.
 */
const BaseModal = (props) => {
  const { mainTitle, subTitle, icon, width, children, ...rest } = props;

  const title = (
    <div className="modal-title">
      { icon &&
        <span className="modal-title-mark">
          <Icon icon={ icon } width={ 20 } />
        </span> }
      <span className="modal-title-text">
        <span className="modal-title-main">{ mainTitle }</span>
        { subTitle && <span className="modal-title-sub">{ subTitle }</span> }
      </span>
    </div>
  );

  return (
    <Modal
      maskClosable={ false }
      destroyOnClose
      title={ title }
      width={ width || 'min(560px, calc(100vw - 32px))' }
      className="base-modal"
      { ...rest }
    >
      <div className="base-model">
        { children }
      </div>
    </Modal>
  );
};

export default BaseModal;
